import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import PracticeList from "./practiceList";
import AccessList from "./accessList";

const UserDetails = ({
  openDetails,
  handleCloseDetailsModal,
  selectedUser,
  fetchUsers,
}) => {
  const [localAccessList, setLocalAccessList] = useState([]);
  const [localPracticeList, setLocalPracticeList] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    if (selectedUser) {
      setLocalAccessList(selectedUser.access_list || []);
      setLocalPracticeList(selectedUser.practice_list || []);
    }
  }, [selectedUser]);

  const handleClose = () => {
    handleCloseDetailsModal();
    if (hasChanges && fetchUsers) {
      fetchUsers();
    }
  };

  return (
    <Dialog open={openDetails} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between" }}
      >
        User Details
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Email
          </Typography>
          <Typography variant="body1">
            {`${selectedUser?.user_id} (${selectedUser?.user_role})`}
          </Typography>
        </Box>

        <AccessList
          localAccessList={localAccessList}
          selectedUser={selectedUser}
          setHasChanges={setHasChanges}
          setLocalAccessList={setLocalAccessList}
        />

        <PracticeList
          localPracticeList={localPracticeList}
          selectedUser={selectedUser}
          setHasChanges={setHasChanges}
          setLocalPracticeList={setLocalPracticeList}
          setSnack={setSnack}
        />
      </DialogContent>
      <Snackbar
        open={snack.open}
        autoHideDuration={2000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default UserDetails;
